import { GOOGLE_API } from "@/Constants/api";
import { parseDetailsAddressComponents } from "@/DataPages/helpers/crm/utils";
import { useQuery } from "@tanstack/react-query";

const API_KEY = import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY;
const FIVE_MINUTES = 300000; // 5 minutes in milliseconds (1000 * 60 * 5)

export function usePlaceDetails({ placeId, enabled = true, fields = "formattedAddress,addressComponents" }: UsePlaceDetailsOptions) {
	const queryEnabled = enabled && !!placeId;

	const query = useQuery<PlaceDetails, Error>({
		queryKey: ["place-details", placeId],
		queryFn: async () => {
			const res = await fetch(`${GOOGLE_API.place}/${placeId}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"X-Goog-Api-Key": API_KEY,
					"X-Goog-FieldMask": fields,
				},
			});
			const { formattedAddress, addressComponents } = await res.json();
			return {
				formattedAddress,
				parsed: parseDetailsAddressComponents(addressComponents),
			};
		},
		enabled: queryEnabled,
		staleTime: FIVE_MINUTES,
		retry: false,
	});

	return {
		details: query.data,
		isLoading: query.isLoading,
		isError: query.isError,
		error: query.error,
	};
}
